import React, { useEffect, useRef } from 'react';
import { Section, Container } from 'components/shared';
import { getFieldValue } from '@sitecore-jss/sitecore-jss-react';
import { Copy } from 'components/components/atoms';
import styled from 'styled-components';
import breakpoints from 'utils/breakpoints';

const StyledHeading = styled.h2`
  margin-bottom: 0px;
  font-size: 1.625rem;
  @media ${breakpoints.lg} {
    font-size: 2.25rem;
  }
  @media ${breakpoints.xl} {
    font-size: 2.875rem;
  }
`;

const StyledCopy = styled(Copy)`
  @media ${breakpoints.lg} {
    width: 40rem;
  }
`;

const IframeContainer = styled.div`
  iframe {
    height: 100%;
  }
`;

const GeneralScript = ({ fields, rendering }) => {
  // Fields
  const title = getFieldValue(fields, 'title');
  const subtitle = getFieldValue(fields, 'text');
  const snipped = getFieldValue(fields, 'codeSnippet');
  const overrideWebsiteStyles = getFieldValue(fields, 'overrideWebsiteStyles');

  const iframeContainerRef = useRef();

  useEffect(() => {
    const parsedHTML = document.createRange().createContextualFragment(snipped);
    if (iframeContainerRef && iframeContainerRef.current) {
      iframeContainerRef.current.appendChild(parsedHTML);
      if (overrideWebsiteStyles) {
        iframeContainerRef.current.classList.remove('cision_widget');
      }
    }
  }, []);

  useEffect(() => {
    if (iframeContainerRef && iframeContainerRef.current) {
      setTimeout(() => {
        if (overrideWebsiteStyles) {
          console.log(iframeContainerRef.current);
          const inputs = iframeContainerRef.current.querySelectorAll('input');
          console.log(inputs);
          if (inputs && inputs.length > 0) {
            for (let i = 0; i < inputs.length; i++) {
              inputs[i].style.border = '2px inset #443355';
            }
          }

          const selects = iframeContainerRef.current.querySelectorAll('select');
          console.log(selects);
          if (selects && selects.length > 0) {
            for (let i = 0; i < selects.length; i++) {
              selects[i].style.border = '2px inset #443355';
            }
          }
        }
      }, 3000);
    }
  }, [iframeContainerRef]);

  if (!snipped) {
    return '';
  }

  return (
    <Section className='pt-0 lg:pt-0'>
      <Container className='flex flex-col items-center'>
        <div className='md:mb-8 flex flex-col items-center'>
          <StyledHeading className='font-bold leading-tiny text-mattamy-blue font-trade-gothic-20 mb-6 md:mb-10-mattamy text-center'>
            {title}
          </StyledHeading>
          <StyledCopy className='md:text-lg text-center'>{subtitle}</StyledCopy>
        </div>

        {snipped && (
          <IframeContainer
            ref={iframeContainerRef}
            className='w-full rounded overflow-auto cision_widget'
          ></IframeContainer>
        )}
      </Container>
    </Section>
  );
};

export default GeneralScript;
